import type { GroupedTask, MinifiedTask, RiskAssessmentSystemTaskData } from '@gcv/shared';
import { TaskStatus } from '@gcv/shared';

import { isGroupedTask } from '../../tasks/tasks.model';

/** Marks the task carrying a risk assessment result as complete, reaching into groups. */
export const getTasksWithResultCompleted = <T extends MinifiedTask | GroupedTask>(
  tasks: T[],
  resultId: string
): T[] => {
  const complete = (task: MinifiedTask) =>
    (task.data as RiskAssessmentSystemTaskData | undefined)?.result_id === resultId
      ? { ...task, status: TaskStatus.COMPLETE }
      : task;

  return tasks.map((task) =>
    isGroupedTask(task) ? { ...task, tasks: task.tasks.map(complete) } : complete(task)
  ) as T[];
};
